export default "__VITE_ASSET__D$rLUsOT__"